import { render, staticRenderFns } from "./RFQCardActions.vue?vue&type=template&id=68ca8c1b&"
import script from "./RFQCardActions.vue?vue&type=script&lang=js&"
export * from "./RFQCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports